import { render, staticRenderFns } from "./InvoiceProfileManagement.vue?vue&type=template&id=127a6d60&scoped=true"
import script from "./InvoiceProfileManagement.vue?vue&type=script&lang=js"
export * from "./InvoiceProfileManagement.vue?vue&type=script&lang=js"
import style0 from "./InvoiceProfileManagement.vue?vue&type=style&index=0&id=127a6d60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a6d60",
  null
  
)

export default component.exports